import { Box, Container, Typography } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"

export default function LandingReason() {
  // const matches = useMediaQuery("(min-width:1000px)")
  return (
    <Box sx={{ mx: { xs: "1em", lg: "3em" } }}>
      <Typography
        variant="h4"
        sx={{ textAlign: "center", my: 4, fontWeight: "bold" }}
      >
        OSTが選ばれる理由
      </Typography>

      <Grid2
        container
        spacing={4}
        sx={{ display: "flex", alignItems: "center" }}
      >
        {/* 幅広い技術分野　始まり */}
        <Grid2 xs={12} sm={5.5}>
          <Container
            sx={{
              p: 1,
              bgcolor: "rgb(238,238,238)", //light grey color  // #eeeeee
              borderRadius: "0.3em",
              display: "flex",
              flexFlow: "column",
              justifyContent: "center",
              height: { sm: "25em" },
            }}
          >
            <Typography
              variant="h4"
              sx={{ textAlign: "center", pb: "1em", fontWeight: "bold" }}
            >
              幅広い技術分野
            </Typography>
            <Typography variant="body1">
              『機械・輸送機器・ロボティクス』、『電気・電子、半導体』、『IT・ソフトウェア』、『化学・医療・バイオ』といった幅広い技術分野において、当社のエンジニアリソースのスケールメリットを活用したサービスをお客様へ提供しています。
            </Typography>
          </Container>
        </Grid2>
        <Grid2
          xs={12}
          sm={6.5}
          sx={{
            display: { xs: "flex", sm: "block" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={"./assets/v1_41.png"}
            alt="a engineer working on a machine"
            sx={{
              width: { xs: "70vw", sm: "100%" },
              height: { sm: "15em", md: "23em" },
              objectFit: "cover",
            }}
          />
        </Grid2>
        {/* 幅広い技術分野　終わり */}
        {/* 取引社数約3800社　始まり */}
        <Grid2
          xs={12}
          sm={6.5}
          sx={{
            display: { xs: "none", sm: "block" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={"./assets/v1_57.png"}
            alt="japan network picture"
            sx={{
              width: { xs: "70vw", sm: "100%" },
              // height: { sm: "15em", md: "25em" },
              objectFit: "cover",
            }}
          />
        </Grid2>
        <Grid2 xs={12} sm={5.5}>
          <Container
            sx={{
              p: 1,
              bgcolor: "rgb(238,238,238)", //light grey color  // #eeeeee
              borderRadius: "0.3em",
              display: "flex",
              flexFlow: "column",
              justifyContent: "center",
              height: { sm: "25em" },
            }}
          >
            <Typography
              variant="h4"
              sx={{ textAlign: "center", pb: "1em", fontWeight: "bold" }}
            >
              取引社数約3,800社
            </Typography>
            <Typography variant="body1">
              全国約3,800社(※グループ全体)の様々な企業様とお取引させていただいています。今後もさらに多くの企業様をサポートすることを目指し、優秀なエンジニアの採用と最適な人材のご提案を行っていきます。また、定期的にお客様アンケートを実施し、当社業務に対しての評価をいただいております。
            </Typography>
          </Container>
        </Grid2>
        <Grid2
          xs={12}
          sm={6.5}
          sx={{
            display: { xs: "flex", sm: "none" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={"./assets/v1_57.png"}
            alt="japan network picture"
            sx={{
              width: { xs: "70vw", sm: "100%" },
              // height: { sm: "15em", md: "25em" },
              objectFit: "cover",
            }}
          />
        </Grid2>

        {/* 取引社数約3800社　終わり */}
        {/* 幅広いジャンルのエンジニア募集　始まり */}
        <Grid2 xs={12} sm={6} md={5.5}>
          <Container
            sx={{
              p: { xs: 1, sm: 0.5, md: 1 },
              bgcolor: "rgb(238,238,238)", //light grey color  // #eeeeee
              borderRadius: "0.3em",
              display: "flex",
              flexFlow: "column",
              justifyContent: "center",
              height: { sm: "40em", md: "30em", lg: "26em" },
            }}
          >
            <Typography
              variant="h4"
              sx={{ textAlign: "center", pb: "1em", fontWeight: "bold" }}
            >
              幅広いジャンルの
              <br />
              ITエンジニアを募集
            </Typography>
            <Typography variant="body1">
              現在募集しているITエンジニアの多くは、JavaやC言語を駆使して業務アプリケーションやパッケージソフトウェアなどの開発を行う開発エンジニアや、AWSやAzureなどのクラウド環境を使用してインフラ基盤の構築、運用保守を行うネットワークエンジニアです。最近では、SwiftやPythonによるモバイルやロボットのアプリ開発エンジニア、WordPressやDrupalなどのオープンソースソフトウェアや、Sitecoreなどのプラットフォームを利用して、大規模なWebサイトやWebアプリケーションを構築するWeb系エンジニア、ソリューションサービスのサポートを担当するサポートエンジニアなども増加傾向です。
            </Typography>
          </Container>
        </Grid2>
        <Grid2
          xs={12}
          sm={6}
          md={6.5}
          sx={{
            display: { xs: "flex", sm: "block" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={"./assets/v2_176.png"}
            alt="engineer network"
            sx={{
              width: { xs: "70vw", sm: "100%" },
              // height: { sm: "15em", md: "25em" },
              objectFit: "cover",
            }}
          />
        </Grid2>
        {/* 幅広いジャンルのエンジニア募集　終わり */}
      </Grid2>
    </Box>
  )
}
